/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const addressState = () => ({ addresses: [] });

const addressSlice = createSlice({
  name: "address",
  initialState: addressState(),
  reducers: {
    setAddresses(state, { payload }) {
      state.addresses = [...payload];
    }
  }
});

export const { setAddresses, clearNewAddress } = addressSlice.actions;

export default addressSlice.reducer;
